import { apiFetch } from "./api";
import type { PagedResult } from "./clients-accounts";

export type EodRunStatus = "Pending" | "Succeeded" | "Failed" | "PartialSuccess" | "Skipped";

export interface EodTotalsDto {
  eodDate: string;
  invoicesTodayCount: number;
  invoicesTodayTotal: number;
  invoicesTodayExGstTotal: number;
  gstTodayTotal: number;
  paymentsReceivedCount: number;
  paymentsReceivedTotal: number;
  refundsTotal: number;
  adjustmentsTotal: number;
  invoicesOutstandingTotal: number;
  clientAccountsTotal: number;
  clientAccountsOverdueTotal: number;
  activeJobsCount: number;
  newJobsCount: number;
  quotesIssuedCount: number;
  updatedOnUtc: string | null;
}

export interface EodTotalsResponse {
  selected: EodTotalsDto | null;
  days: EodTotalsDto[];
}

export interface EodCalendarDayDto {
  date: string;
  status: EodRunStatus | null;
}

export interface EodRunListItemDto {
  eodRunId: number;
  accountingDate: string;
  runStartedUtc: string;
  runFinishedUtc: string | null;
  triggeredBy: string;
  status: EodRunStatus;
  rowsWritten: number;
  correlationId: string | null;
}

export interface EodRunDetailDto extends EodRunListItemDto {
  rerunReason: string | null;
  errorSummary: string | null;
}

export interface ListRunsParams {
  from?: string;
  to?: string;
  status?: EodRunStatus;
  triggeredBy?: "Schedule" | "Manual";
  page?: number;
  pageSize?: number;
}

function qs(params: Record<string, string | number | undefined>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== "") sp.set(k, String(v));
  const s = sp.toString();
  return s ? `?${s}` : "";
}

export const eodApi = {
  totals: (date: string, period: "day" | "week" | "month" | "custom" = "day", from?: string, to?: string) =>
    apiFetch<EodTotalsResponse>(`/api/reports/eod-totals${qs({ date, period, from, to })}`),
  calendar: (month: string) =>
    apiFetch<EodCalendarDayDto[]>(`/api/reports/eod-totals/calendar${qs({ month })}`),
  listRuns: (params: ListRunsParams = {}) =>
    apiFetch<PagedResult<EodRunListItemDto>>(`/api/reports/eod-audit${qs(params as Record<string, string | number | undefined>)}`),
  getRun: (id: number) => apiFetch<EodRunDetailDto>(`/api/reports/eod-audit/${id}`),
  rerun: (body: { accountingDate: string; reason: string }) =>
    apiFetch<{ jobId: string }>(`/api/admin/eod/rerun`, { method: "POST", body: JSON.stringify(body) }),
};
